module.exports = new __parcel__URL__("pvp_draw_icon.ffd57ccb.png").toString();